import { DownOutlined } from "@ant-design/icons";
import {
	Input,
	Modal,
	Dropdown,
	Typography,
	Table,
	Menu,
	Checkbox,
	DatePicker,
	Progress,
} from "antd";
import { ColumnsType, TablePaginationConfig } from "antd/lib/table";
import React, { useEffect, useState } from "react";
import { api } from "services/api";
import Swal from "sweetalert2";
// import { DataType } from "types";

export const AddStudentInCourseModal: React.FC<any> = ({ ...props }) => {
	const [selectedValue, setSelecteValue] = useState<string>("10");
	const [allUsers, setAllUsers] = useState<any[]>();
	const [usersWithAccess, setUsersWithAccess] = useState<any[]>([]);
	const [allUsersWithProgress, setAllUsersWithProgress] = useState<any[]>([]);
	const [totalItensValue, setTotalItensValue] = useState<number>(0);
	const [paginationInfo, setPaginationInfo] = useState<TablePaginationConfig>();
	const {
		form,
		isOpen,
		setCurrentImgURL,
		setIsOpen,
		setCourseStatus,
		currentCourseData,
	} = props;
	const handleRegister = (values: any) => {
		api
			.post(`/courses/${currentCourseData?.id}/users/add`, values)
			.then((result) => {
				if ([200, 201].includes(result.status)) {
					const {
						data: { feedback },
					} = result;
					form.resetFields();
					Swal.fire({
						icon: "success",
						text: feedback["success"],
						confirmButtonColor: "#63b8cd",
					}).then(() => {
						setIsOpen(false);
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			})
			.catch((err) => {
				const status = err.response.status;
				const { feedback, errors } = err.response?.data;
				if (
					status === 400 ||
					status === 401 ||
					status === 404 ||
					status === 403 ||
					status === 500
				) {
					Swal.fire({
						icon: "error",
						text: feedback["error"]
							? feedback["error"]
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
				if (status === 422) {
					Swal.fire({
						icon: "error",
						text: errors?.message
							? errors?.message
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			});
	};
	const menu = (
		<Menu
			selectable
			// @ts-ignore
			onClick={(e) => setSelecteValue(e.key)}
			defaultSelectedKeys={["3"]}
			items={[
				{
					key: "10",
					label: "10",
				},
				{
					key: "20",
					label: "20",
				},
				{
					key: "30",
					label: "30",
				},
				{
					key: "40",
					label: "40",
				},
			]}
		/>
	);

	const columns: ColumnsType<any> = [
		{
			title: "Nome",
			dataIndex: "name",
			key: "name",
			render: (_, record) => (
				<p style={{ margin: 0 }}>{record?.person?.name}</p>
			),
			onCell: () => {
				return {
					width: "12.5%",
				};
			},
		},
		{
			title: "E-mail",
			dataIndex: "email",
			key: "email",
			onCell: () => {
				return {
					width: "12.5%",
				};
			},
		},
		{
			title: "Data de nascimento",
			dataIndex: "birth_date",
			key: "birth_date",
			render: (text, record) => (
				<p style={{ margin: 0 }}>
					{record?.person?.birth_date ? record?.person?.birth_date : "-"}
				</p>
			),
			onCell: () => {
				return {
					width: "12.5%",
				};
			},
		},
		// {
		// 	title: "Status",
		// 	dataIndex: "status",
		// 	key: "status",
		// 	onCell: () => {
		// 		return {
		// 			width: "10",
		// 		};
		// 	},
		// },
		{
			title: "Progresso no curso",
			key: "",
			render: (_) => (
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					{allUsersWithProgress.map((user) => user.user_id).includes(_.id) ? (
						<Progress
							percent={
								allUsersWithProgress.find(({ user_id }) => user_id === _.id)
									.progress
							}
							strokeWidth={8}
							showInfo={false}
						/>
					) : (
						"-"
					)}
				</div>
			),
			onCell: () => {
				return {
					width: "15%",
				};
			},
		},
		{
			title: "Acesso ao curso",
			key: "start_access",
			render: (_, record) => (
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<Checkbox
						checked={usersWithAccess.map((user) => user.user_id).includes(_.id)}
						onChange={(e) => {
							if (e.target.checked) {
								setUsersWithAccess((prevState) => {
									if (prevState.map((item) => item.user_id).includes(_.id)) {
										return prevState;
									}
									return [...prevState, { user_id: _.id }];
								});
								return;
							}
							setUsersWithAccess((prevState) =>
								prevState.filter((itens) => itens.user_id !== _.id)
							);
						}}
					/>
				</div>
			),
			onCell: () => {
				return {
					width: "15%",
				};
			},
		},
		{
			title: "Acesso até",
			key: "end_access",
			render: (_, record) => (
				<div style={{ width: "100%" }}>
					<DatePicker
						format={"DD/MM/YYYY"}
						placeholder={"Selecione uma data"}
						style={{ width: "90%" }}
						showToday={false}
						onChange={(_, date) => {
							setUsersWithAccess((prevState) => {
								const currentUser = prevState
									.map((item) => item.user_id)
									.indexOf(record.id);
								if (currentUser !== -1) {
									prevState[currentUser] = {
										...prevState[currentUser],
										expires_data: date,
									};
									return prevState;
								}
								return prevState;
							});
						}}
					/>
				</div>
			),
			onCell: () => {
				return {
					width: "20%",
				};
			},
		},
	];

	useEffect(() => {
		setAllUsers(undefined);
		api
			.get(
				`/manager/users?per_page=${selectedValue}&paginate=true&page=${
					paginationInfo?.current ? paginationInfo.current : 1
				}`
			)
			.then((res) => {
				setAllUsers(res.data.data.users);
				setTotalItensValue(Number(res?.data?.pagination?.total));
			});
	}, [selectedValue, paginationInfo]);

	useEffect(() => {
		if (isOpen) {
			setUsersWithAccess([]);
			api.get(`/courses/${currentCourseData?.id}/students`).then((res) => {
				setUsersWithAccess(
					res.data.data.users.map((item: any) => {
						return { user_id: item.id };
					})
				);
			});
		}
	}, [isOpen, currentCourseData]);

	useEffect(() => {
		if (usersWithAccess.length && currentCourseData) {
			setAllUsersWithProgress([]);
			usersWithAccess.map(({ user_id }) => {
				api
					.get(`/courses/${currentCourseData.id}/users/${user_id}/progress`)
					.then((res) => {
						setAllUsersWithProgress((prevState) => [
							...prevState,
							{ user_id, progress: res.data.data },
						]);
					});
				return null;
			});
		}
	}, [usersWithAccess, currentCourseData, isOpen]);

	return (
		<Modal
			title={<p style={{ margin: 0 }}>Curso - {currentCourseData?.title}</p>}
			open={isOpen}
			maskClosable={false}
			okText="Adicionar alunos"
			cancelText="Cancelar"
			onOk={() => {
				form
					.validateFields()
					.then((values: any) => {
						const allValues = {
							users: usersWithAccess,
						};
						form.resetFields();
						console.log(allValues);
						handleRegister(allValues);
						setCurrentImgURL("");
						setCourseStatus(false);
					})
					.catch((info: any) => {
						console.log("Validate Failed:", info);
					});
			}}
			onCancel={() => {
				setIsOpen(!isOpen);
				setCurrentImgURL("");
			}}
			className="m-modal-students"
		>
			<div className="m-courses-new-student-modal">
				<div className="m-courses-new-student-modal__container">
					<h1 className="m-courses-new-student-modal__container__title">
						Adicionar Alunos
					</h1>
					<div className="m-courses-new-student-modal__container__input">
						<div className="m-courses-new-student-modal__container__input__user-number">
							Exibir{" "}
							{
								<Dropdown overlay={menu}>
									<Typography.Text>
										{selectedValue}
										<DownOutlined style={{ marginLeft: "5px" }} />
									</Typography.Text>
								</Dropdown>
							}{" "}
							usuários
						</div>
						<Input placeholder="Pesquisar..." className="student-input" />
					</div>
					<Table
						loading={allUsers === undefined}
						columns={columns}
						dataSource={allUsers}
						onChange={(e) => setPaginationInfo(e)}
						pagination={{
							total: totalItensValue,
							showSizeChanger: false,
							pageSize: +selectedValue,
						}}
					/>
				</div>
			</div>
		</Modal>
	);
};
